import axios from 'axios'

const baseURL = window.location.origin

if (!baseURL) {
  throw new Error('Backend URL is not set')
}

const catchError = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('Sentry caught error -> ', ...args)
    return
  }
  import('../instrument').then(({ default: sentryClient }) => {
    sentryClient.captureException(...args)
  })
}

export default async function getApiClient(idToken = null) {
  let token = null
  if (idToken) {
    token = idToken
  } else {
    token = await window.shopify.idToken()
  }
  const client = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'x-shop': shopify.config.shop,
    },
  })

  client.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      // This block handles non-2xx responses or request failures

      if (error.response) {
        // Server responded with a status code outside 2xx
        const status = error.response.status
        const responseData = error.response.data
        catchError(error, {
          tags: {
            status,
            endpoint: error.config?.url,
            method: error.config?.method,
            error: JSON.stringify(error.config?.data || {})
          },
          extra: {
            responseData,
            requestData: error.config?.data,
          },
        })
      } else if (error.request) {
        console.log(
          '[API ERROR] No response received from server.',
          error.request,
        )
      } else {
        console.error('[API ERROR] Request setup error:', error.message)
      }
      return Promise.reject(error)
    },
  )
  return client
}
